import { render, staticRenderFns } from "./Step3B.vue?vue&type=template&id=04a64d17&"
import script from "./Step3B.vue?vue&type=script&lang=js&"
export * from "./Step3B.vue?vue&type=script&lang=js&"
import style0 from "./Step3B.vue?vue&type=style&index=0&id=04a64d17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports